import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Costanti } from '../costanti';

@Injectable({ providedIn: 'root' })
export class NotificaService {
  private BASEURL = Costanti.APIURL + 'notifiche/';

  checkNotifiche = new Subject<boolean>();

  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private http: HttpClient) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }

  lista(): Observable<JSON[]> {
    const url = this.BASEURL + 'lista-notifiche';

    this.loadingSubject.next(true);
    const body = {};

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  listaUltimeNotifiche(): Observable<JSON[]> {
    const url = this.BASEURL + 'lista-notifiche';

    this.loadingSubject.next(true);
    const body = { limit: 1 };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  updateLettaNotifica(id_notifica): Observable<JSON> {
    const url = this.BASEURL + 'leggi-notifica';

    this.loadingSubject.next(true);
    const body = { id_notifica };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
}
